const judgeMeProductLinkSelector = 'a.jdgm-carousel-item__product';

const labelJudgeMeProductLink = (link) => {
  if (link.getAttribute('aria-label')) return;

  const productTitle = link
    .querySelector('.jdgm-carousel-item__product-title')
    ?.textContent.trim();

  link.setAttribute('aria-label', productTitle || 'View reviewed product details');
};

const labelJudgeMeProductLinksWithin = (node) => {
  if (!(node instanceof Element)) return;

  if (node.matches(judgeMeProductLinkSelector)) {
    labelJudgeMeProductLink(node);
  }

  node.querySelectorAll(judgeMeProductLinkSelector).forEach(labelJudgeMeProductLink);
};

labelJudgeMeProductLinksWithin(document.documentElement);

const judgeMeAccessibilityObserver = new MutationObserver((records) => {
  records.forEach((record) => record.addedNodes.forEach(labelJudgeMeProductLinksWithin));
});

judgeMeAccessibilityObserver.observe(document.documentElement, {
  childList: true,
  subtree: true,
});

window.setTimeout(() => judgeMeAccessibilityObserver.disconnect(), 20000);
